var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('modal',{ref:"verMapa",attrs:{"titulo":"Ubicar tienda en el mapa","tamano":"modal-xl","icon":"location"}},[_c('mapa',{ref:"el_mapa",staticStyle:{"width":"100%","height":"50vh"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }